import { render } from "./DeleteIcon.vue?vue&type=template&id=045e851c&scoped=true"
const script = {}

import "./DeleteIcon.vue?vue&type=style&index=0&id=045e851c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045e851c"],['__file',"src/components/elements/DeleteIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "045e851c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('045e851c', __exports__)) {
    api.reload('045e851c', __exports__)
  }
  
  module.hot.accept("./DeleteIcon.vue?vue&type=template&id=045e851c&scoped=true", () => {
    api.rerender('045e851c', render)
  })

}


export default __exports__